import React from "react";

import "./SongRow.css";

function SongRow({ item, index }) {
  console.log("SongRow item: ", item);
  const {
    track: { album, artists, name },
  } = item;

  let artists_display = artists
    .slice(0, 4)
    .map((a) => a.name)
    .join(", ");
  if (artists.length > 3) {
    artists_display += " ...";
  }

  return (
    <div className="songRow">
      <div className="songRow__number">{index + 1}</div>
      <div className="songRow__image">
        <img src={album?.images && album?.images[0].url} alt="Album art" />
      </div>
      <div className="songRow__ta">
        <div className="songRow__ta--trackName">
          <strong>{name}</strong>
        </div>
        <div className="songRow__ta--artistName">{artists_display}</div>
      </div>
      <div className="songRow__albumName">{album?.name}</div>
    </div>
  );
}

export default SongRow;
